const gotoDp = (skuId: string | number) => {
  location.href = `/dp/${skuId}`;
};

const getDpUrl = (skuId: string | number) => {
  return `/dp/${skuId}`;
};

export { gotoDp, getDpUrl };
